import { Injectable } from '@angular/core';
import {Query,Mutation, gql, Apollo} from 'apollo-angular';
import { Subject } from 'rxjs';

const queryCompany = gql`
query{
  company{
      id
      displayId
      name
      isCompanyNameHiddenInRfq
      logoImageUrl
      primaryEmail
      billingEmail
      procurementEmail
      salesEmail
      website
      locations{
          id
          label
          country
          province
          city
          street
          postalCode
          phone
          taxId
          isMainAddress
      }
      type
      userClassifiedIndustry
      systemClassifiedIndustry
      defaultCurrency
      isTaxExempt
      documents{
          id
          type
          imageUrl
          uploadedFileName
      }
      corporateGroup
      vendorToInvite{
          id
          name
          contact
      }
      subscriptionChoiceIdDuringRegistration
      isAutoRenewSubscription
      registrationIp
      registeredCountry {
          id
          countryName
          currency
      }
      companyTag {
          id
          tag
          isActive
      }
      createdDate
      createdBy
      modifiedDate
      modifiedBy
      isPKP
      isApproval
  }
}
`;

const queryCompanyName = gql`
query{
  company{
    name
    isApproval
  }
}
`;

const querygiveReportAndFeedback = gql`
mutation giveReportAndFeedback($ReportAndFeedbackInput:ReportAndFeedbackInput!){
  giveReportAndFeedback(input: $ReportAndFeedbackInput)
}
`;

const mutationChooseCompany = gql`
mutation chooseCompany($companyId: ID!, $loginEventId: ID!) {
  chooseCompany(input: {companyId: $companyId,  loginEventId: $loginEventId}) {
      __typename,
      ...on ChooseCompanyResponse {
          isFirstTimeLogin,
          viewPreferences,
          rfqId,
          staff {
              id,
              roleMembership,
              isActive,
              companyId,
              createdDate,
              createdBy,
              modifiedDate,
              modifiedBy
          },
          accessToken
      }
      ...on DomainError {
          errorMessage
      }
      ...on UnacceptedTermConditionError {
          latestTermCondition {
              id
          }
      }
  }
}
`;

const getCompanyCurrency = gql`
query{
  company{
    defaultCurrency
  }
}
`;



const agreeToTermCondition = gql`
mutation agreeToTermCondition($termConditionId: ID!){
  agreeToTermCondition(input: {
      termConditionId:$termConditionId
  })
}
`;

const getCompanyLogo = gql`
query{
  getCompanyLogo
}

`;

const deleteCompanyLocation = gql`
mutation deleteCompanyLocation($companyLocationId:ID!){
  deleteCompanyLocation(input: {
      companyLocationId: $companyLocationId
  })
}
`;

const viewCompanyDashBoard = gql`
query{
  viewCompanyDashBoard{
      isFillLocation
      isInputProduct
      isInputRfq
      isInputStaff
      isMakeQuotation
      totalProduct
      totalRfq
      totalStaff
      totalQuotation
      totalProductUnpublished
      totalRfqUnpublished
      totalStaffInactive
      totalQuotationUnpublished
  }
}  
`;

const getcompanylocation = gql`
query{
  getCompanyLocationList{
      id
      label
      country
      province
      city
      street
      postalCode
      phone
      taxId
      isMainAddress
  }
}
`;

const getWhatsappCompanyData = gql`
query {
    getWhatsappCompanyData {
        isEnable
        whatsappToken
        phoneId
        phoneNumber
        whatsappAccountId
    }
}
`;

const enableDisableWhatsapp = gql`
mutation enableDisableWhatsapp($isEnable: Boolean!, $whatsappToken: String!, $phoneId: String!, $phoneNumber: String!, $whatsappAccountId: String!){
    enableDisableWhatsapp(input: {
        isEnable: $isEnable
        whatsappToken: $whatsappToken
        phoneId: $phoneId
        phoneNumber: $phoneNumber
        whatsappAccountId: $whatsappAccountId
    })
}
`;

const backupChat = gql`
query {
    backupChat {
        messageThreadId
        whatsappInternalId
        fromNumber
        fromWho
        totalNewMessage
        threadStatus
        messageDetail {
            messageThreadDetailId
            messageThreadId
            direction
            messageType
            content
            mediaUrl
            metaMessageId
            status
          statusTime
        }
    }
}
`;

const getActiveSubscriptionInfoPrice = gql`
query getActiveSubscriptionInfoPrice($input: NewPurchasedSubscriptionInput!) {
    getActiveSubscriptionInfoPrice(input: $input) {
        subscriptionBuyingOption
        priceReductionResult
        existingSubscriptionDaysUsed
        existingSubscriptionPrice
        existingTotalSubscriptionInDays
        existingSubscriptionExpiredDate
        newSubscriptionPrice
    }
}
`;

const getActiveFhProduct = gql`
  query {
    getActiveFhProduct {
      proformaInvoiceDetailId
      productCategory
      offeringLabel
      offeredQty
      activeDate
      expiredDate
      subscriptionFeatures {
        featureName
        featureDesc
        featureAvailableQty
      }
    }
  }
`;


@Injectable({ providedIn: 'root' })

export class CompanyService{

    queryCompanyObs = new Subject();
    CompanyNameObs = new Subject();
    mutationChooseCompanyObs = new Subject();
    getCompanyCurrencyObs = new Subject();
    agreeToTermConditionObs = new Subject();
    getCompanyLogoObs = new Subject();
    deleteCompanyLocationObs = new Subject();
    viewCompanyDashBoardObs = new Subject();
    getcompanylocationObs = new Subject();
    getWhatsappCompanyDataObs = new Subject();
    enableDisableWhatsappObs = new Subject();
    backupChatObs = new Subject();
    getActiveSubscriptionInfoPriceObs = new Subject();
    getActiveFhProductObs = new Subject();

    constructor(private apollo: Apollo) {}

    CompanyDetail() {
        this.apollo
        .mutate({
          mutation: queryCompany,
          errorPolicy: 'all',
        })
        .subscribe(
          (res:any) => {
            this.queryCompanyObs.next(res);
            console.log("succes, get data:", res);
          },
          (error) => {
            this.queryCompanyObs.next(error)
            console.log("there was an error sending the query", error);
          }
        );
    }

    getCompanyDetail() {
        this.queryCompanyObs = new Subject();
        this.CompanyDetail();
        return this.queryCompanyObs.asObservable();
    }

    CompanyName() {
      this.apollo
      .mutate({
        mutation: queryCompanyName,
        errorPolicy: 'all',
      })
      .subscribe(
        (res:any) => {
          this.CompanyNameObs.next(res);
          console.log("succes, get data:", res);
        },
        (error) => {
          this.CompanyNameObs.next(error)
          console.log("there was an error sending the query", error);
        }
      );
    }

    getCompanyName() {
      this.CompanyNameObs = new Subject();
      this.CompanyName();
      return this.CompanyNameObs.asObservable();
    }
    

    giveReportAndFeedback(ReportAndFeedbackInput:any) {
      this.apollo
      .mutate({
        mutation: querygiveReportAndFeedback,
        errorPolicy: 'all',
        variables: {ReportAndFeedbackInput: ReportAndFeedbackInput},
      })
      .subscribe(
        (res:any) => {
          this.CompanyNameObs.next(res);
          console.log("succes, get data:", res);
        },
        (error) => {
          this.CompanyNameObs.next(error)
          console.log("there was an error sending the query", error);
        }
      );
    }

    getgiveReportAndFeedback(ReportAndFeedbackInput:any) {
      this.CompanyNameObs = new Subject();
      this.giveReportAndFeedback(ReportAndFeedbackInput);
      return this.CompanyNameObs.asObservable();
    }


    mutationChooseCompany(companyId:string,loginEventId:string) {
        this.apollo
        .mutate({
          mutation: mutationChooseCompany,
          errorPolicy: 'all',
          variables: {
            companyId: companyId,
            loginEventId: loginEventId
          },
        })
        .subscribe(
          (res:any) => {
            this.mutationChooseCompanyObs.next(res);
            console.log("succes, get data:", res);
          },
          (error) => {
            this.mutationChooseCompanyObs.next(error)
            console.log("there was an error sending the query", error);
          }
        );
    }

    getmutationChooseCompany(companyId:string,loginEventId:string) {
        this.mutationChooseCompanyObs = new Subject();
        this.mutationChooseCompany(companyId,loginEventId);
        return this.mutationChooseCompanyObs.asObservable();
    }

    getCompanyCurrency() {
        this.apollo
        .mutate({
          mutation: getCompanyCurrency,
          errorPolicy: 'all',
        })
        .subscribe(
          (res:any) => {
            this.getCompanyCurrencyObs.next(res);
            console.log("succes, get data:", res);
          },
          (error) => {
            this.getCompanyCurrencyObs.next(error)
            console.log("there was an error sending the query", error);
          }
        );
    }

    getgetCompanyCurrency() {
        this.getCompanyCurrencyObs = new Subject();
        this.getCompanyCurrency();
        return this.getCompanyCurrencyObs.asObservable();
    }

    
    CompanyLogo() {
        this.apollo
        .mutate({
          mutation: getCompanyLogo,
          errorPolicy: 'all',
        })
        .subscribe(
          (res:any) => {
            this.getCompanyLogoObs.next(res);
            console.log("succes, get data:", res);
          },
          (error) => {
            this.getCompanyLogoObs.next(error)
            console.log("there was an error sending the query", error);
          }
        );
    }

    getCompanyLogo() {
        // this.getCompanyLogoObs = new Subject();
        this.CompanyLogo();
        return this.getCompanyLogoObs.asObservable();
    }

    agreeToTermCondition(termConditionId:any) {
        this.apollo
        .mutate({
          mutation: agreeToTermCondition,
          errorPolicy: 'all',
          variables: {
            termConditionId: termConditionId
          },
        })
        .subscribe(
          (res:any) => {
            this.agreeToTermConditionObs.next(res);
            console.log("succes, get data:", res);
          },
          (error) => {
            this.agreeToTermConditionObs.next(error)
            console.log("there was an error sending the query", error);
          }
        );
    }

    getagreeToTermCondition(termConditionId:any) {
        this.agreeToTermConditionObs = new Subject();
        this.agreeToTermCondition(termConditionId);
        return this.agreeToTermConditionObs.asObservable();
    }


    deleteCompanyLocation(companyLocationId:any) {
      this.apollo
      .mutate({
        mutation: deleteCompanyLocation,
        errorPolicy: 'all',
        variables: {companyLocationId: companyLocationId},
      })
      .subscribe(
        (res:any) => {
          this.deleteCompanyLocationObs.next(res);
          console.log("succes, get data:", res);
        },
        (error) => {
          this.deleteCompanyLocationObs.next(error)
          console.log("there was an error sending the query", error);
        }
      );
    }

    postdeleteCompanyLocation(companyLocationId:any) {
      this.deleteCompanyLocationObs = new Subject();
      this.deleteCompanyLocation(companyLocationId);
      return this.deleteCompanyLocationObs.asObservable();
    }

    viewCompanyDashBoard() {
      this.apollo
      .mutate({
        mutation: viewCompanyDashBoard,
        errorPolicy: 'all',
      })
      .subscribe(
        (res:any) => {
          this.viewCompanyDashBoardObs.next(res);
          console.log("succes, get data:", res);
        },
        (error) => {
          this.viewCompanyDashBoardObs.next(error)
          console.log("there was an error sending the query", error);
        }
      );
    }

    getviewCompanyDashBoard() {
      this.viewCompanyDashBoardObs = new Subject();
      this.viewCompanyDashBoard();
      return this.viewCompanyDashBoardObs.asObservable();
    }
    
    companylocation() {
      this.apollo
      .mutate({
        mutation: getcompanylocation,
        errorPolicy: 'all',
      })
      .subscribe(
        (res:any) => {
          this.getcompanylocationObs.next(res);
          console.log("succes, get data:", res);
        },
        (error) => {
          this.getcompanylocationObs.next(error)
          console.log("there was an error sending the query", error);
        }
      );
    }

    getcompanylocation() {
      this.getcompanylocationObs = new Subject();
      this.companylocation();
      return this.getcompanylocationObs.asObservable();
    }
    
  
    whatsappCompanyData() {
      this.apollo
      .mutate({
        mutation: getWhatsappCompanyData,
        errorPolicy: 'all',
      })
      .subscribe(
        (res:any) => {
          this.getWhatsappCompanyDataObs.next(res);
          console.log("succes, get data:", res);
        },
        (error) => {
          this.getWhatsappCompanyDataObs.next(error)
          console.log("there was an error sending the query", error);
        }
      );
    }

    getWhatsappCompanyData() {
      this.getWhatsappCompanyDataObs = new Subject();
      this.whatsappCompanyData();
      return this.getWhatsappCompanyDataObs.asObservable();
    }    

    enableDisableWhatsapp(isEnable:boolean, whatsappToken:string, phoneId:string, phoneNumber:string, whatsappAccountId:string) {
      this.apollo
      .mutate({
        mutation: enableDisableWhatsapp,
        errorPolicy: 'all',
        variables: {
          isEnable: isEnable,
          whatsappToken: whatsappToken,
          phoneId: phoneId,
          phoneNumber: phoneNumber,
          whatsappAccountId: whatsappAccountId
        },
      })
      .subscribe(
        (res:any) => {
          this.enableDisableWhatsappObs.next(res);
          console.log("succes, get data:", res);
        },
        (error) => {
          this.enableDisableWhatsappObs.next(error)
          console.log("there was an error sending the query", error);
        }
      );
    }

    postEnableDisableWhatsapp(isEnable:boolean, whatsappToken:string, phoneId:string, phoneNumber:string, whatsappAccountId:string) {
      this.enableDisableWhatsappObs = new Subject();
      this.enableDisableWhatsapp(isEnable, whatsappToken, phoneId, phoneNumber, whatsappAccountId);
      return this.enableDisableWhatsappObs.asObservable();
    }


    backupChat() {
      this.apollo
      .mutate({
        mutation: backupChat,
        errorPolicy: 'all',
      })
      .subscribe(
        (res:any) => {
          this.backupChatObs.next(res);
          console.log("succes, get data:", res);
        },
        (error) => {
          this.backupChatObs.next(error)
          console.log("there was an error sending the query", error);
        }
      );
    }

    getBackupChat() {
      this.backupChatObs = new Subject();
      this.backupChat();
      return this.backupChatObs.asObservable();
    }   

    getgetActiveSubscriptionInfoPrice(input: any) {
      return this.apollo.mutate({
        mutation: getActiveSubscriptionInfoPrice,
        errorPolicy: 'all',
        variables: { input: input },
        fetchPolicy: 'no-cache',
      });
    }

    getActiveFhProduct() {
      this.apollo
      .mutate({
        mutation: getActiveFhProduct,
        errorPolicy: 'all',
      })
      .subscribe(
        (res: any) => {
          this.getActiveFhProductObs.next(res);
          console.log("succes, get data:", res);
        },
        (error) => {
          this.getActiveFhProductObs.next(error);
          console.log("there was an error sending the query", error);
        }
      );
    }

    getgetActiveFhProduct() {
      this.getActiveFhProductObs = new Subject();
      this.getActiveFhProduct();
      return this.getActiveFhProductObs.asObservable();
    }

}